import React from "react";
import T from "prop-types";
import { Button } from "MODULES/shared/components";
import { renderIf } from "MODULES/shared/decorators";
import api from "APP_ROOT/api";
import { toastr } from "react-redux-toastr";

const ExportButton = ({ searchProps }) => {
  const params = searchProps.paginator.get("filters").toJS();

  return (
    <Button
      onClick={() => {
        api.outboundOrders.export(params).then(() => {
          toastr.info("Processing Report.");
        });
      }}
    >
      Export
    </Button>
  );
};

ExportButton.propTypes = {
  searchProps: T.shape({
    paginator: T.instanceOf(Map)
  })
};

const meetsExportCriteria = renderIf(
  ({ searchProps }) => searchProps.paginator.get("totalCount") <= 100
);

const DecoratedExportButton = meetsExportCriteria(ExportButton);

export default DecoratedExportButton;



// WEBPACK FOOTER //
// ./app/modules/Shipping/components/Dashboard/ExportButton.jsx